import React from "react";
import { Checkbox, Typography } from "antd";
import { useTranslation } from "react-i18next";
import GaebTags from "./GaebTags";
import "./gaeb.css";

const { Paragraph, Text } = Typography;

/** LV-Bereich headings the offer editor shows before a position (calc.js#titleHeaders). */
export const GaebHeadings = ({ ozList, titles }) =>
  ozList.length ? (
    <div className="gaeb-ui gaeb-headings">
      {ozList.map(oz => (
        <div key={oz} className="gaeb-headings__row">
          <strong>{oz}</strong> {titles.get(oz) || ""}
        </div>
      ))}
    </div>
  ) : null;

/**
 * GAEB facts above a position in the offer editor: OZ, kind, the long text (collapsed), and
 * for Bedarfs-/Alternativpositionen whether the customer ordered them (only then they count).
 */
const GaebItemInfo = ({ item, counts, onChange }) => {
  const { t } = useTranslation("dashboard");
  const g = item?.gaeb;
  if (!g) return null;
  const optional = g.kind === "alternative" || Boolean(g.provisional);
  return (
    <div className="gaeb-ui gaeb-item">
      <div className="gaeb-item__head">
        <Text strong className="gaeb-item__oz">
          {g.oz}
        </Text>
        <GaebTags item={item} />
        {!counts && <Text type="secondary">{t("Not in the total")}</Text>}
      </div>
      {item.longText && item.longText !== item.description ? (
        <Paragraph
          className="gaeb-item__text"
          type="secondary"
          ellipsis={{ rows: 2, expandable: true, symbol: t("Show long text") }}
        >
          {item.longText}
        </Paragraph>
      ) : null}
      {optional && (
        <Checkbox
          checked={Boolean(g.awarded)}
          onChange={e => onChange({ ...g, awarded: e.target.checked })}
        >
          {t("Ordered by the customer")}
        </Checkbox>
      )}
    </div>
  );
};

export default GaebItemInfo;
